import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckIcon, MessageCircleIcon } from 'lucide-react';
import { useSeo } from '../utils/seo';
import { FinanciacionForm } from '../components/forms/FinanciacionForm';
import { ButtonAnchor } from '../components/ui/Button';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../utils/vehicles';
const beneficios = ['Asesoramiento personalizado', 'Opciones para 0KM', 'Evaluación rápida', 'Toma de usado como parte de pago', 'Consulta sin compromiso'];
export function Financiacion() {
  const [params] = useSearchParams();
  useSeo('Financiación y 0KM | VCARS', 'Accedé a tu próximo 0KM con asesoramiento personalizado: planes, cuotas y toma de usado como parte de pago.');
  return <main className="bg-ink" data-id="element-456" data-mp="ug8gig4xap80">
      <div className="border-b border-line bg-surface" data-id="element-457" data-mp="18d5gp86xlj1k">
        <div className="mx-auto grid w-full max-w-7xl gap-10 px-5 py-14 md:grid-cols-[1.1fr_1fr] md:px-8 md:py-20" data-id="element-458" data-mp="18bkmjjoj4248">
          <div data-id="element-459" data-mp="14a8wjd1qtevi">
            <h1 className="text-4xl font-black leading-[1.05] tracking-tight text-white md:text-[52px]" data-id="element-460" data-mp="1i6ysahovbhr0">
              Financiación y 0KM
            </h1>
            <p className="mt-5 text-lg font-semibold text-white/90" data-id="element-461" data-mp="1m8kdqrfgx4ct">
              Accedé a tu próximo 0KM con asesoramiento personalizado.
            </p>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-mist" data-id="element-462" data-mp="1w6qdb2dsxyei">
              Te ayudamos a encontrar la mejor opción según tu presupuesto, necesidad y
              perfil. Consultá planes, cuotas y alternativas de financiación.
            </p>
            <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-463" data-mp="254s993ioi0ux">
              {beneficios.map(b => <li key={b} className="flex items-start gap-2.5 text-[15px] text-white/90" data-id="element-464" data-mp="2a07lxs4y9qpr">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-neon" aria-hidden="true" data-id="element-465" data-mp="2ez2gfrca53pp" />
                  {b}
                </li>)}
            </ul>
            <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="lg" className="mt-8" data-id="element-466" data-mp="2ovx7xqa4y3uh">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-467" data-mp="1u8yh9706n8jp" />
              Hablar con un vendedor
            </ButtonAnchor>
          </div>
          <FinanciacionForm vehiculoInicial={params.get('vehiculo') ?? ''} data-id="element-468" data-mp="28ymkidrxcha2" />
        </div>
      </div>
    </main>;
}